<script>
    import { metaInfo } from "@/core/MetaInfo";
    import StatusOrder from "@/components/status/StatusOrder";

    export default {
        name: "Status",
        components: { StatusOrder },
        computed: {
            statusOrderId() {
                return this.$route.params.id;
            },
        },
        metaInfo() {
            return metaInfo.getMeta("status");
        },
    };
</script>

<template>
    <div class="status-page">
        <div class="l-container">
            <h1 class="status-page__title">Статус заказа</h1>
            <status-order :status-order-id="statusOrderId"></status-order>
        </div>
    </div>
</template>

<style lang="scss">
    .status-page {
        max-width: 520px;
        width: 100%;
        margin: 0 auto;
        padding: 24px 0;
        @include bp($bp-desktop-sm) {
            min-height: 500px;
            padding: 56px 0 60px;
        }
    }

    .status-page__title {
        margin-bottom: 16px;
        font-family: var(--typography-heading-font);
        font-size: 26px;
        font-weight: var(--typography-heading-weight);
        line-height: 40px;
        text-transform: var(--typography-heading-case);
        @include bp($bp-desktop-sm) {
            margin-bottom: 32px;
            font-size: 36px;
            line-height: 40px;
        }
    }
</style>
